import React from "react"
import Container from "../../atoms/Container"
import "./OverOnsInfo.css"

export default function OverOnsInfo({ block }) {
  return (
    <Container>
      <div className="vt-whitespace-container"></div>
      <div className="vt-overonsinfo-container">
        <p
          className="vt-overonsinfo-tekstvlak"
          dangerouslySetInnerHTML={{ __html: block.tekstvlak }}
        ></p>
        <div className="vt-whitespace-container-120"></div>
      </div>
    </Container>
  )
}
